import { putApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_reactions'

type Operation = operations['messenger_upd_reaction_to_message_updateReaction']
type Response = Operation['responses']['204']
type Body = Operation['parameters']['body']['body']

export const updateReactionApi = (
  messageUuid: string,
  reactionId: number,
  newReactionId: number
) => {
  return putApi<Response, Body>(
    `/messages/${messageUuid}/reactions/${reactionId}` as '/messages/{messageId}/reactions/{reactionId}',
    {
      messageId: messageUuid,
      reactionId,
      newReactionId,
    }
  )
}
